/* =========================================================
   GLightbox（WP画像ブロックのみ）
   ・PDF除外
   ・外部リンク除外
========================================================= */
export function initLightboxWpBlockImage() {
  window.addEventListener('load', () => {
    const links = document.querySelectorAll('.entry-content a[href]');

    links.forEach((a) => {
      const href = a.getAttribute('href');
      if (!href) return;

      // 外部リンク除外
      const url = new URL(href, location.href);
      if (url.hostname !== location.hostname) return;

      // PDF除外
      if (/\.pdf$/i.test(url.pathname)) return;

      // 画像リンクのみ（念のため）
      if (!/\.(jpg|jpeg|png|webp|gif)$/i.test(url.pathname)) return;

      a.classList.add('js-lightbox');
    });

    if (!document.querySelector('.entry-content a.js-lightbox')) return;

    GLightbox({
      selector: '.entry-content a.js-lightbox',
      touchNavigation: true,
      loop: true,
    });
  });
}
